import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing, palette }) => ({
  headerButtons: {
    display: 'flex',
    gap: '8px',
  },
  container: {
    display: 'flex',
    width: '100%',
    height: '100%',
    padding: '32px',
    flexDirection: 'column',
  },

  editIcon: {
    width: spacing(12),
    height: spacing(12),
    color: 'white',
    fill: 'white',
  },
  button: {
    height: '43px',
    width: '100px',
    padding: '10px 16px',
  },
  subcontainer: {
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '38px 22px 12px',
    marginBottom: '30px',
    flexDirection: 'column',
    border: '1px solid #E3E3E3',
    borderRadius: '8px',
    gap: '24px',
  },
  overrideAlign: {
    alignItems: 'stretch !important',
  },
  headerContainer: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr',
    maxWidth: '1000px',
  },
  wrapper: {
    display: 'grid',
    gridTemplateColumns: '300px 300px 400px',
    alignContent: 'center',
    alignItems: 'center',
    marginRight: 'auto',
    width: '100%',
    gap: '44px',
  },
  input: {
    maxWidth: '400px',
    alignSelf: 'flex-start',
  },
  jsonDefinition: {
    gridColumn: 'span 2',
  },
  textArea: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: spacing(60),
    paddingLeft: spacing(12),
    gap: spacing(16),
  },
  label: {
    display: 'flex',
    color: `${Theme.Colors.Grayscale.OneThousand} !important`,
    fontSize: spacing(12),
    marginBottom: spacing(8),
    fontWeight: 500,
    whiteSpace: 'nowrap',
  },
  required: {
    color: Theme.Colors.Red.Base,
    marginLeft: spacing(4),
  },
  title: {
    color: palette.gray[32],
    marginTop: spacing(6),
  },
  alignTop: {
    alignSelf: 'flex-start',
  },
  inputLabel: {
    color: `${Theme.Colors.Grayscale.OneThousand} !important`,
    fontFamily: Theme.Typography.FontFamily.DMSans,
    fontWeight: Theme.Typography.FontWeight.Medium,
    fontSize: `${Theme.Typography.FontSize.Tiny}px !important`,
  },
  selectLabel: {
    marginBottom: '4px',
  },
  errorMessage: {
    margin: 0,
    marginTop: spacing(2),
    color: `${palette.error.main} !important`,
    fontSize: spacing(10.5),
    fontFamily: 'Roboto',
    height: spacing(10),
  },
}))
